// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_o6-0";
export var discountCodeInput = "_o6-1";